const mutations = {
    setPersonalAccountNumber (state, personalAccountNumber) {
        state.personalAccountNumber = personalAccountNumber
    },
}

export default mutations
